import { message } from "antd"

const renderErrorMessage = (errors) => {
  console.log('You got some errors...', errors)

  // TODO: write a generic function to parse errors received from server
  message.destroy()
  message.error(errors[0])

}

export default renderErrorMessage